/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const policyPlanComponentListResponseItemPolicyPlanRadarTagsItemSeverityMin = 0;
export const policyPlanComponentListResponseItemPolicyPlanRadarTagsItemSeverityMax = 5;

export const PolicyPlanComponentListResponse = zod
	.array(
		zod
			.object({
				case_sensitive: zod.boolean().nullable().describe('Pattern case sensitivity'),
				content: zod.string().nullable().describe('Document content'),
				directive_id: zod.uuid().nullable().describe('Directive reference'),
				enabled: zod.boolean().describe('Whether the component is active'),
				id: zod.string().describe('Component ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				kind: zod.string().describe('Component kind: detection or directive'),
				patterns: zod.array(zod.string()).nullable().describe('Pattern strings'),
				policy_directive: zod
					.object({
						duration_seconds: zod.number().nullish().describe('Duration in seconds'),
						id: zod.string().optional().describe('Directive config ID'),
						require_approval: zod
							.boolean()
							.optional()
							.describe('Whether this directive requires manual approval')
					})
					.optional(),
				policy_plan_radar: zod
					.object({
						tags: zod
							.array(
								zod.object({
									severity: zod
										.number()
										.min(policyPlanComponentListResponseItemPolicyPlanRadarTagsItemSeverityMin)
										.max(policyPlanComponentListResponseItemPolicyPlanRadarTagsItemSeverityMax)
										.describe('Severity level (0-5)'),
									tag: zod
										.object({
											description: zod.string().nullable().describe('Tag description'),
											formats: zod
												.array(zod.string())
												.describe('Content formats this tag applies to'),
											id: zod.string().describe('Tag ID'),
											inserted_at: zod.iso
												.datetime({ offset: true })
												.describe('Creation timestamp'),
											key: zod.string().describe('Tag key identifier'),
											name: zod.string().describe('Tag name'),
											organization_id: zod.string().nullable().describe('Organization ID'),
											source: zod.string().describe('Tag source (builtin or custom)'),
											suggested_severity: zod
												.number()
												.nullable()
												.describe('Suggested severity level (0-5)'),
											updated_at: zod.iso
												.datetime({ offset: true })
												.describe('Last update timestamp')
										})
										.optional()
										.describe('A tag for categorizing and organizing case items'),
									tag_id: zod.uuid().describe('Tag ID'),
									threshold_override: zod
										.number()
										.nullish()
										.describe('Per-tag threshold override (0.0-1.0)')
								})
							)
							.optional()
							.describe('Tag entries'),
						default_threshold: zod
							.number()
							.optional()
							.describe('Default confidence threshold (0.0-1.0)'),
						id: zod.string().optional().describe('Radar config ID')
					})
					.optional(),
				policy_plan_version_id: zod.uuid().describe('Version this component belongs to'),
				position: zod.number().describe('Display order position'),
				type: zod.string().describe('Component type: document, pattern, radar, or directive'),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
			})
			.describe('A policy plan component')
	)
	.describe('List of policy plan components');

export type PolicyPlanComponentListResponse = zod.input<typeof PolicyPlanComponentListResponse>;
export type PolicyPlanComponentListResponseOutput = zod.output<
	typeof PolicyPlanComponentListResponse
>;
